export const VALIDATION_STATUS = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  VALID: 'VALID'
}
